import React from 'react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../context/authContext';
import { useNavigate } from 'react-router-dom';

function Home() {
    const { userLoggedIn } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!userLoggedIn) {
            navigate('/login');
        }
    }, [userLoggedIn]);

    return (
        <div className="content-container flex-grow flex items-center justify-center">
            <div className="flex space-x-8">
            <Link
                    to="/srt-generator"
                    className="block bg-indigo-500 hover:bg-indigo-700 text-gray-900 font-bold py-12 px-16 rounded-lg shadow-xl text-center"
                >
                    <div className="text-4xl mb-2 w-40">
                        <img src="/images/sm-logo.png" alt="Headphones" className="h-16 w-[auto] mx-auto" />
                    </div>
                    <div className="text-lg">SRT Generator</div>
                </Link>
                <Link
                    to="/video-annotator"
                    className="block bg-indigo-500 hover:bg-indigo-700 text-gray-900 font-bold py-12 px-16 rounded-lg shadow-xl text-center"
                >
                    <div className="text-4xl mb-2 w-40">
                        <img src="/images/audio-description.png" alt="Headphones" className="h-16 w-16 mx-auto" />
                    </div>
                    <div className="text-lg">Audio Description</div>
                </Link>
                <Link
                    to="/audio-converter"
                    className="block bg-indigo-500 hover:bg-indigo-700 text-gray-900 font-bold py-12 px-16 rounded-lg shadow-xl text-center"
                >
                    <div className="text-4xl mb-2 w-40">
                        <img src="/images/elevenlabs.png" alt="Headphones" className="h-16 mx-auto" />
                        {/* <FaHeadphones /> */}
                    </div>
                    <div className="text-lg">Audio Converter</div>
                </Link>
                <Link
                    to="/audio-converter-polly"
                    className="block bg-indigo-500 hover:bg-indigo-700 text-gray-900 font-bold py-12 px-16 rounded-lg shadow-xl text-center"
                >
                    <div className="text-4xl mb-2 w-40">
                        <img src="/images/amazon-polly.png" alt="Headphones" className="h-16 mx-auto" />
                        {/* <FaHeadphones /> */}
                    </div>
                    <div className="text-lg">Audio Converter</div>
                </Link>

            </div>
        </div>
    );
}

export default Home;